import emailMarketing from "../../../images/emailMarketing.png";

export const EmailMarketing = () => {
  return (
    <section className="section-sp2">
      <div className="container inner-content email-marketing-container">
        <div style={{ maxWidth: "640px" }}>
          <h2>Effective HCP Email Marketing</h2>
          <h3 className="text-primary">
            How powerful would you feel if you could extend your digital
            marketing into HCP email marketing? -{" "}
            <span className="text-secondary">
              You would feel like a marketing superhero!
            </span>
          </h3>
          <p>
            You know how challenging it can be to get HCP email campaigns past
            filters and firewalls. That’s why you need a partner with advanced
            technology, four-step verification, precise data, and optimized,
            spam-resistant messaging—ensuring your emails reach the right
            inboxes every time.
          </p>
        </div>
        <img src={emailMarketing} alt="" />
      </div>
    </section>
  );
};
